/* Merch PDP: the turn, size carry-over, phone bar. Sells without it. */
(function (wire) {
  'use strict';
  if (window.__pikloMpd) return;
  window.__pikloMpd = true;
  function all() {
    [].forEach.call(document.querySelectorAll('[data-mpd]'), function (el) {
      if (!el.__mpd) { el.__mpd = true; wire(el); }
    });
  }
  all();
  document.addEventListener('shopify:section:load', all);
})(function (root) {
  'use strict';
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var phone = matchMedia('(max-width: 759px)');
  var mo = document.documentElement.classList.contains('mo');
  var mat = $('[data-mat]'), track = $('[data-track]'), frames = $$('[data-frame]');
  var cur = 0, TURN = [0, 2, 1], KEY = 'piklo-mpd-turned';   // front, angle, back = images 1, 3, 2

  function mark(i) {
    cur = i;
    $$('.mpd__seg [data-go]').forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.go === i); });
    $$('.mpd__thumb, .mpd__dot').forEach(function (b) {
      if (+b.dataset.go === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
  }
  function show(i) {
    if (!frames[i]) return;
    if (phone.matches) track.scrollTo({ left: frames[i].offsetLeft - track.offsetLeft, behavior: mo ? 'smooth' : 'auto' });
    else frames.forEach(function (f, n) { f.classList.toggle('is-on', n === i); });
    mark(i);
    if (mat) mat.classList.remove('is-hint');   // found the controls: the drag hint has done its job for this visit
  }
  $$('[data-go]').forEach(function (b) { b.addEventListener('click', function () { show(+b.dataset.go); }); });

  if (track && frames.length > 1) {
    var tick = 0;   // phones: the dots follow the swipe
    track.addEventListener('scroll', function () {
      if (!phone.matches) return;
      cancelAnimationFrame(tick);
      tick = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / (track.scrollWidth / frames.length));
        if (i !== cur && frames[i]) mark(i);
      });
    }, { passive: true });
    phone.addEventListener('change', function () { show(cur); });

    // desktop: a third of the stage per frame, mouse/pen
    if (frames.length >= 3) {
      var drag = null;
      try { if (matchMedia('(hover: hover) and (pointer: fine)').matches && !localStorage.getItem(KEY)) mat.classList.add('is-hint'); } catch (e) {}
      track.addEventListener('pointerdown', function (e) {
        if (phone.matches || e.pointerType === 'touch' || e.button !== 0) return;
        drag = { x: e.clientX, w: track.clientWidth / 3, t: Math.max(0, TURN.indexOf(cur)) };
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        mat.classList.add('is-drag');
        e.preventDefault();
      });
      track.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x, n = Math.trunc(Math.abs(dx) / drag.w);
        // from an end, either way turns inward; from the angle, left = back
        var t = drag.t === 0 ? n : drag.t === 2 ? 2 - n : 1 + Math.trunc(-dx / drag.w);
        t = TURN[Math.max(0, Math.min(2, t))];
        if (t === cur) return;
        show(t);
        if (mat.classList.contains('is-hint')) {
          mat.classList.remove('is-hint');
          try { localStorage.setItem(KEY, '1'); } catch (err) {}
        }
      });
      var end = function () { drag = null; mat.classList.remove('is-drag'); };
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { track.addEventListener(ev, end); });
    }
  }

  /* size: price, labels, color links, ?variant= */
  var form = $('form[action*="/cart/add"]'), add = $('[data-add]');
  var radios = $$('input[name="id"][type="radio"]'), sizes = $('.mpd__sizes'), msg = $('[data-msg]');
  var txt = function (s, v) { $$(s).forEach(function (el) { el.textContent = v; }); };
  function pick(r, push) {
    if (!r) return;
    var title = r.dataset.title, price = r.dataset.cost, sz = $('[data-bar-sz]');
    txt('[data-size-now]', title); txt('[data-bar-size]', title);
    if (sz) sz.hidden = false;
    txt('[data-price]', price); txt('[data-bar-price]', price);
    if (add && !form.dataset.busy) add.textContent = add.textContent.replace(/·.*$/, '· ' + price);
    if (sizes) sizes.classList.remove('is-err');
    txt('[data-msg]', '');
    $$('.mpd__sw').forEach(function (a) {
      var base = a.dataset.href, id = ('|' + a.dataset.map + '|').split('|' + title + '=')[1];
      a.href = id ? base + (base.indexOf('?') < 0 ? '?' : '&') + 'variant=' + id.split('|')[0] : base;
    });
    if (push) {
      var u = new URL(location.href);
      u.searchParams.set('variant', r.value);
      history.replaceState(history.state, '', u);
    }
  }
  pick($('input[name="id"]:checked'));   // ?variant= or a restored form
  // no size: say so beside the pills
  var errAt = 0;
  radios.forEach(function (r) {
    r.addEventListener('change', function () { pick(r, true); });
    r.addEventListener('invalid', function (e) {
      e.preventDefault();
      if (Date.now() - errAt < 300) return;   // every radio in the group fires it
      errAt = Date.now();
      sizes.classList.add('is-err');
      msg.textContent = 'Pick a size first.';
      sizes.scrollIntoView({ block: 'center', behavior: mo ? 'smooth' : 'auto' });
      $('input[name="id"]:enabled').focus({ preventScroll: true });
    });
  });

  /* phone bar: on once the main button is gone under the sticky header, off over
     the footer. Measured against the header's bottom, not 0: the button hides
     behind the header ~70px before it leaves the screen. A scroll check: a jump
     past the button never crosses an observer's edge. */
  var bar = $('[data-bar]'), ftr = document.querySelector('.ftr__cta') || document.querySelector('.ftr__sign') || document.querySelector('.ftr'), hdr = document.querySelector('.hdr'), raf = 0;
  if (bar && add) {
    bar.hidden = false;
    var paint = function () {
      raf = 0;
      var edge = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
      bar.classList.toggle('is-on', add.getBoundingClientRect().bottom < edge &&
        !(ftr && ftr.getBoundingClientRect().top < innerHeight - 90));   // stay on over the footer's blurb, off before any footer control
    };
    addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
    paint();
  }
});
